import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import styles from './style.module.scss';
const BAR_COUNT = 24;
const DECAY_PER_TICK_MS = 200;
const DECAY_RATE = 0.92;
const AudioPeakIndicator = ({ peakLevel }) => {
    const [displayLevel, setDisplayLevel] = useState(0);
    const displayRef = useRef(0);
    useEffect(() => {
        displayRef.current = Math.max(displayRef.current, peakLevel);
        setDisplayLevel(displayRef.current);
    }, [peakLevel]);
    useEffect(() => {
        const id = window.setInterval(() => {
            displayRef.current *= DECAY_RATE;
            if (displayRef.current < 0.01) {
                displayRef.current = 0;
            }
            setDisplayLevel(displayRef.current);
        }, DECAY_PER_TICK_MS);
        return () => window.clearInterval(id);
    }, []);
    return (_jsx("div", { className: styles.peakIndicator, "aria-hidden": true, children: Array.from({ length: BAR_COUNT }, (_, index) => {
            const threshold = (index + 1) / BAR_COUNT;
            const active = displayLevel >= threshold;
            return (_jsx("div", { className: clsx(styles.peakBar, active && styles.peakBarActive) }, index));
        }) }));
};
export default AudioPeakIndicator;
